var _desc, _defs, _clipPath, _clipPath2, _clipPath3, _clipPath4, _clipPath5, _clipPath6, _clipPath7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAifIntegrity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with SVGMaker Editor 3.4.1")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    "data-editor-group": "true",
    transform: "matrix(1 0 0 1 13.7344 9.75)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -1.73441 2.25)",
    clipPath: "url(#CLIPPATH_1020)"
  }, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "CLIPPATH_1020"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(1 0 0 1 0.00001 0)",
    x: -12,
    y: -12,
    width: 24,
    height: 24
  }))), /*#__PURE__*/React.createElement("path", {
    transform: " translate(-11.99999, -12)",
    style: {
      fill: "rgb(1,60,102)"
    },
    strokeLinecap: "round",
    d: "M 17.3994 12 C 17.3994 11.839 17.3922 11.685 17.3778 11.524 L 18.7169 10.537 C 19.0048 10.327 19.084 9.935 18.904 9.627 L 17.5578 7.366 C 17.4715 7.21773 17.3318 7.1057 17.1657 7.05143 C 16.9996 6.99717 16.8188 7.00449 16.6579 7.072 L 15.1101 7.709 C 14.8437 7.527 14.5629 7.366 14.2677 7.233 L 14.059 5.616 C 14.0158 5.266 13.7062 5 13.3463 5 L 10.6609 5 C 10.2938 5 9.98422 5.266 9.94103 5.616 L 9.73225 7.233 C 9.43708 7.366 9.15631 7.527 8.88994 7.709 L 7.34212 7.072 C 7.01095 6.932 6.6222 7.058 6.44221 7.366 L 5.09596 9.634 C 4.91598 9.942 4.99518 10.327 5.28314 10.544 L 6.6222 11.531 C 6.59218 11.8453 6.59218 12.1617 6.6222 12.476 L 5.28314 13.463 C 4.99518 13.673 4.91598 14.065 5.09596 14.373 L 6.44221 16.634 C 6.6222 16.942 7.01095 17.068 7.34212 16.928 L 8.88994 16.291 C 9.15631 16.473 9.43708 16.634 9.73225 16.767 L 9.94103 18.384 C 9.98422 18.734 10.2938 19 10.6537 19 L 13.3391 19 C 13.699 19 14.0086 18.734 14.0518 18.384 L 14.2606 16.767 C 14.5557 16.634 14.8365 16.473 15.1029 16.291 L 16.6507 16.928 C 16.9818 17.068 17.3706 16.942 17.5506 16.634 L 18.8968 14.373 C 19.0768 14.065 18.9976 13.68 18.7097 13.463 L 17.3706 12.476 C 17.3922 12.315 17.3994 12.161 17.3994 12 Z M 12.0288 14.45 C 10.6394 14.45 9.50908 13.351 9.50908 12 C 9.50908 10.649 10.6394 9.55 12.0288 9.55 C 13.4182 9.55 14.5485 10.649 14.5485 12 C 14.5485 13.351 13.4182 14.45 12.0288 14.45 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -1.73441 -7.25)",
    clipPath: "url(#CLIPPATH_1021)"
  }, _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "CLIPPATH_1021"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(1 0 0 1 0.0312 9.83203)",
    x: -12,
    y: -12,
    width: 24,
    height: 24
  }))), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "rgb(237,28,36)"
    },
    cx: 0,
    cy: 0,
    r: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 6.7344 -2.58203)",
    clipPath: "url(#CLIPPATH_1022)"
  }, _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "CLIPPATH_1022"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(1 0 0 1 0.0312 9.83203)",
    x: -12,
    y: -12,
    width: 24,
    height: 24
  }))), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "rgb(237,28,36)"
    },
    cx: 0,
    cy: 0,
    r: 2,
    vectorEffect: "non-scaling-stroke"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 12 21.5)",
    clipPath: "url(#CLIPPATH_1023)"
  }, _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "CLIPPATH_1023"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(1 0 0 1 0.0312 9.83203)",
    x: -12,
    y: -12,
    width: 24,
    height: 24
  }))), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "rgb(237,28,36)"
    },
    cx: 0,
    cy: 0,
    r: 2,
    vectorEffect: "non-scaling-stroke"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 20.4688 17)",
    clipPath: "url(#CLIPPATH_1024)"
  }, _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "CLIPPATH_1024"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(1 0 0 1 0.0312 9.83203)",
    x: -12,
    y: -12,
    width: 24,
    height: 24
  }))), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "rgb(237,28,36)"
    },
    cx: 0,
    cy: 0,
    r: 2,
    vectorEffect: "non-scaling-stroke"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 3.6 17)",
    clipPath: "url(#CLIPPATH_1025)"
  }, _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    id: "CLIPPATH_1025"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(1 0 0 1 0.0312 9.83203)",
    x: -12,
    y: -12,
    width: 24,
    height: 24
  }))), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "rgb(237,28,36)"
    },
    cx: 0,
    cy: 0,
    r: 2,
    vectorEffect: "non-scaling-stroke"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 3.6 7.08399)",
    clipPath: "url(#CLIPPATH_1026)"
  }, _clipPath7 || (_clipPath7 = /*#__PURE__*/React.createElement("clipPath", {
    id: "CLIPPATH_1026"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(1 0 0 1 0.0312 9.83203)",
    x: -12,
    y: -12,
    width: 24,
    height: 24
  }))), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "rgb(237,28,36)"
    },
    cx: 0,
    cy: 0,
    r: 2,
    vectorEffect: "non-scaling-stroke"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAifIntegrity);
export default __webpack_public_path__ + "static/media/aif-integrity.f603133e18f5d9269dc111a039bb5672.svg";
export { ForwardRef as ReactComponent };